import ToastManager from './toast-manager';

export default new ToastManager();
